import axiosInstance from '@/utils/api.js'

var state = {
  dialupServiceLink: []
}

var getters = {
  DIALUP_SERVICE_LINK: (state) => {
    return state.dialupServiceLink
  }
}

var mutations = {
  SET_DIALUP_SERVICE_LINK: (state, payload) => {
    state.dialupServiceLink = payload || []
  }
}

var actions = {
  GET_DIALUP_SERVICE_LINK: async (context, payload) => {
    let result = await axiosInstance.get('/users/servicelinks/dialup?slink_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_DIALUP_SERVICE_LINK', result.data)
    }
  },
  CREATE_DIALUP_SERVICE_LINK: (context, payload) => {
    return axiosInstance.post('/users/servicelinks/dialup', payload)
  },
  UPDATE_DIALUP_SERVICE_LINK: (context, payload) => {
    return axiosInstance.put('/users/servicelinks/dialup', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/servicesLinkDialup.js